import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% - 40px);
    margin-top: 5px;

    div + div {
        margin-left: 10px;
    }
`;

const Item = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: ${theme.white};
    max-width: 110px;
    border-radius: 8px;
    padding-top: 8px;
    padding-inline: 5px;
    text-align: center;
    cursor: pointer;

    strong {
        font-size: 12px;
        font-weight: 700;
        color: ${theme.textLight};
        text-transform: uppercase;
    }

    span {
        font-size: 28px;
        font-weight: 900;
        color: ${theme.textDark};
    }

    small {
        max-width: 85px;
        font-size: 11px;
        font-weight: 400;
        color: ${theme.textDark};
    }

    button {
        font-size: 13px;
        font-weight: 700;
        color: ${theme.primaryColor};
        padding-bottom: 8px;
    }
`;

export { Container, Item };